/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseItemAdminResponseModel } from '../../models/purchase-item-admin-response-model';

export interface GetPurchaseItemById$Params {
  purchaseId: string;
  purchaseItemId: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getPurchaseItemById(http: HttpClient, rootUrl: string, params: GetPurchaseItemById$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseItemAdminResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getPurchaseItemById.PATH, 'get');
  if (params) {
    rb.path('purchaseId', params.purchaseId, {});
    rb.path('purchaseItemId', params.purchaseItemId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseItemAdminResponseModel>;
    })
  );
}

getPurchaseItemById.PATH = '/purchases/{purchaseId}/items/{purchaseItemId}';
